// @flow
import React from 'react';
import injectSheet from 'react-jss';
import {
  FONT_FAMILY_ROBOTO
} from 'shared/constants';

type Props = {
  classes: Object,
  label: string,
  url: string,
  underLineColor: string,
  color: string,
  colorTheme: 'DARK' | 'LIGHT',
  openInNewTab: Boolean,
  onClick: () => void
};

function UnderlinedButton({ label, url, classes: c, openInNewTab, onClick }: Props) {
  return (
    <a className={c.container} href={url} target={openInNewTab ? '_blank' : null} rel='noreferrer noopener' onClick={onClick}>
      <div className={c.label}>
        {label}
      </div>
    </a>
  );
}

const styles = {
  container: {
    fontFamily: FONT_FAMILY_ROBOTO,
    borderBottom: (props) => `2px solid ${props.underLineColor || (props.colorTheme === 'DARK' ? '#949599' : 'black')} `,
    paddingLeft: '15px',
    paddingRight: '15px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: (props) => {
      if(props.color){
        return props.color;
      }

      if (props.colorTheme === 'DARK') {
        return 'white';
      }
      return 'black';
    },
    textTransform: 'uppercase',
    paddingBottom: '12px',
    textDecoration: 'none',
    lineHeight: '1em',
    marginRight: '5px',
    marginLeft: '5px',
    fontSize: '14px',
    letterSpacing: '0.8px',
    minWidth: '140px',
    textAlign: 'center',
    '@media(max-width: 425px)': {
      marginTop: '18px',
      marginBottom: '18px'
    },
    '@media(min-width: 900px)': {
      fontSize: '20px',
    },
  },
  icon: {
    marginLeft: '5px'
  }
};

export default injectSheet(styles)(UnderlinedButton);
